import React from 'react';
import { Route, Routes } from 'react-router-dom';
import MainContent from './pages/MainContent';
import TwoMinute from './pages/TwoMinute';
import TenMinute from './pages/TenMinute';
import OneHour from './pages/OneHour';
import Evidence from './pages/EvidenceByDecade';
import Application from './pages/UN';
import Violations from './pages/Violations';
import Documents from './pages/Documents';
import Negligence from './pages/Negligence';
import Contact from './pages/Contact';
import Sign from './pages/Sign';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<MainContent/>} />
      <Route path="/twominute" element={<TwoMinute/>} />
      <Route path="/tenminute" element={<TenMinute/>} />
      <Route path="/onehour" element={<OneHour/>} />
      <Route path="/evidence" element={<Evidence/>} />
      <Route path="/un" element={<Application/>} />
      <Route path="/violations" element={<Violations/>} />
      <Route path="/documents" element={<Documents/>} />
      <Route path="/negligence" element={<Negligence/>} />
      <Route path="/contact" element={<Contact/>} />
      <Route path="/signup" element={<Sign/>} />
    </Routes>
  );
}

export default App;
